import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { LocalStoreManager, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import {
  Customer,
  CustomerContactNumber,
  CustomerAddress,
  PersonalityKindEnum,
  GenderEnum,
  CreditControlType,
  MaxCodeViewModel,
  ZoneLookup,
} from "../model/customer.model";
import { take } from "rxjs/operators";
import { NumberType, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormGroup, Validators } from "@angular/forms";
import { Zone } from "../model/zone.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { CustomerCategory } from "../model/customer-categories.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { Branch, form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { SplashScreenService } from "../../../../../projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { ChangeCachEnum } from "../../order/model/changecach.enum";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { SaleMethodBranchModel } from "../../sales/model/sale-method-branch.model";
import { MapComponent, MapConfirmValue } from "../map/map.component";
import { Subject } from "rxjs";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { PersianService } from "projects/sepidz-web-framework/src/lib/services/persian.service";
import { Party } from "../model/party.model";

@Component({
  selector: "ngx-customer-form",
  templateUrl: "./customer-form.component.html",
  styleUrls: ["./customer-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerFormComponent extends BaseFormComponent<Customer> implements AfterViewInit {
  @ViewChild("telephoneListGridEl") telephoneListGridEl: EditableGridComponent;
  haserror: boolean = false;
  erroremessage: string;
  activeTabTitle: String;
  zones: Zone[] = [];
  hasCredit: boolean = false;
  hasLegalCustomer: boolean = false;
  DefaultValues: Dictionary = [];
  Customer: Customer;
  Addresses: form_control[];
  Numbers: form_control[];
  Occasions: form_control[];
  NumberTypeLookup: Lookup[];
  zonesLookup: ZoneLookup[] = [];
  PersonalityKindLookup: Lookup[];
  GenderLookup: Lookup[] = [];
  TitleLookup: Lookup[];
  BranchLookUp: Branch[];
  CallerIdNumber: string;
  isFindCustomer: boolean;
  isDisFinish: Number = 0;
  SoftWareLicenseKind = SoftWareLicenseKind;
  public isDefaultCustomer: boolean;
  public FirstNameChange: boolean;
  selectedZoneId: number;
  selectedZone: Zone;
  public Zones: Zone[];
  isMobileType: boolean = false;
  isPhoneType: boolean = false;
  disableNumber: boolean = false;
  showDefaultBranch: boolean = false;
  defaultBranchIsInit: boolean;
  showAddressGrid: boolean = false;
  gridShippingCostHasChanged: boolean;
  oldGridShippingCost: any;
  saleMethodBranch: SaleMethodBranchModel;
  currentAddressGridRow: CustomerAddress;
  LookupIsLoading: Dictionary = [];
  public DeactiveHasCreate: boolean = false;
  public NationalLabel: string = "";
  public isNationalCodeRequired: boolean = false;
  public isNationalIdRequired: boolean = false;
  public hasEconomicCode: boolean = false;
  public hasRegistrationNumber: boolean = false;
  public hasRegistrationDate: boolean = false;
  public hasPostalCode: boolean = false;
  public nameIsNotNecessary = true;
  public hasClubCustomer = false;
  public LastName: string;
  public nationalCodePattern: string = "^[0-9]\\d{9}";
  public nationalIdPattern: string = "^[0-9]{10,15}$";
  disabledTitle: boolean = false;
  personalityKindEnum = PersonalityKindEnum;
  showZone: boolean = false;
  creditCustmer: boolean;
  currentInformation = this.accountService.authService.currentInformation();
  currentBranch = this.accountService.authService.currentBranch;
  customerCategories: CustomerCategory[];
  controlsIsAdded: boolean;
  constructor(
    private lookupService: LookupService,
    protected selectorService: SelectorService,
    public cd: ChangeDetectorRef,
    public splash: SplashScreenService,
    private storage: LocalStoreManager,
    private persianService: PersianService
  ) {
    super(selectorService, cd);
    this.addCustomerFormGroup();
  }

  async fillData() {
    this.hasCreditCustomar();
    this.setValue("ZoneId", null);
    this.setValue("GenderId", null);
    const computerName: string = this.storage.getData(ClearableCache.ComputerName);

    const cacheState = await this.httpCommonService
      .get<any[]>(`LocalSetting/GetCachState` + (computerName ? "?ComputerName=" + computerName : ""))
      .pipe(take(1))
      .toPromise();

    if (cacheState) {
      if (cacheState.some((f) => f === ChangeCachEnum.Zone) && this.storage.getData("zonesLookup")) {
        this.zonesLookup = this.storage.getData("zonesLookup");
        this.selectorService.setDataList("Zone/GetZonesList", this.zonesLookup);
        if (this.currentInformation.RestaurantCallCenter && this.currentBranch.AccessToAllBranches) {
          this.showDefaultBranch = true;
          this.showZone = true;
        }
      } else await this.GetZone();
    } else await this.GetZone();

    const branchLookUp = await this.httpCommonService.getList<Branch[]>("Branch").pipe(take(1)).toPromise();
    this.BranchLookUp = branchLookUp.filter((x) => !x.AccessToAllBranches && x.IsActive);
    this.selectorService.setDataList("Branch", this.BranchLookUp);
    if (this.model?.Addresses?.length > 0 && this.BranchLookUp?.length > 0 && this.currentInformation.RestaurantCallCenter) this.setDefaultBranchId();

    this.PersonalityKindLookup = await this.lookupService.getLookupbyCategory("GNR", "PersonalityKind").pipe(take(1)).toPromise();
    this.GenderLookup = await this.lookupService.getLookupbyCategory("GNR", "Gender").pipe(take(1)).toPromise();
    this.NumberTypeLookup = await this.lookupService.getLookupbyCategory("SALE", "NumberType").pipe(take(1)).toPromise();
    this.customerCategories = await this.httpCommonService.getList<CustomerCategory[]>("CustomerCategory").pipe(take(1)).toPromise();
  }

  async ngOnInit() {
    await this.fillData();
    super.ngOnInit();
    this.apiName = "Customer";
    this.DefaultValues["BranchId"] = 0;
    this.DefaultValues["CustomerId"] = 0;
    this.DefaultValues["Order"] = 0;
    this.setValue("PercentDiscount", "");
    this.label = this.translate("ClientApp.FrontOffice.Parties.Customer.Customer");
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.zones = undefined;
    this.DefaultValues = undefined;
    this.Customer = undefined;
    this.Addresses = undefined;
    this.Numbers = undefined;
    this.Occasions = undefined;
  }
  setColumnAttribute(): void {
    if (!this.columns) return;
    super.setColumnAttribute();
    this.Addresses = this.getDetailControlModels("Addresses");
    if (!this.currentInformation.RestaurantCallCenter) {
      const defaultBranch = this.Addresses.find((x) => x.name === "DefaultBranchId");
      defaultBranch.formVisible = false;
      defaultBranch.listVisible = false;
    }
    const zone = this.Addresses.find((x) => x.name === "ZoneId");
    zone.isSelector = true;
    this.defaultBranchIsInit = true;
    this.Numbers = this.getDetailControlModels("Numbers");
    this.Occasions = this.getDetailControlModels("Occasions");
    const accountingKind = this.currentInformation.AccountingKind;
    const isAcc = accountingKind === SoftWareLicenseKind.AccountingAdvancedWeb || accountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb;
    const inventoryKind = this.currentInformation.InventoryKind;
    this.orignalColumns.forEach((x) => {
      if (x.name === "SubLedgerId" || x.name === "DetailLedgerId") x.formVisible = isAcc;
      if (x.name === "GoodsId")
        x.formVisible =
          inventoryKind === SoftWareLicenseKind.InventoryWeb ||
          inventoryKind === SoftWareLicenseKind.InventoryAdvancedWeb ||
          inventoryKind === SoftWareLicenseKind.InventoryToAdvancedWeb;
    });
  }

  async GetZone() {
    const data = await this.httpCommonService.getList<ZoneLookup[]>("Zone/GetZones").pipe(take(1)).toPromise();
    this.zonesLookup = data;
    this.storage.savePermanentData(data, "zonesLookup");
    this.selectorService.setDataList("Zone/GetZonesList", this.zonesLookup);
    if (this.currentInformation.RestaurantCallCenter && this.currentBranch.AccessToAllBranches) {
      this.showDefaultBranch = true;
      this.showZone = true;
    }
  }

  async saveForm() {
    if (this.hasClubCustomer) {
      let phoneNumber = this.formGroup.controls["PhoneNumber"].value;
      if (!phoneNumber.startsWith("09")) {
        this.submitted = false;
        this.selectorService.submitted$.next(this.submitted);
        this.isClosing = false;
        this.isSaving = false;
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Parties.Customer.PhoneNumberPatternNotCorrect")}`,
          this.translate("ClientApp.FrontOffice.Parties.Customer.ErrorMessage")
        );
        this.selectorService.submitted$.next(false);
        return;
      }
      if (!this.formGroup.controls["GenderId"].value) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Parties.Customer.CustomerGenderNotSelected")}`,
          this.translate("ClientApp.FrontOffice.Parties.Customer.ErrorMessage")
        );
        this.submitted = false;
        this.selectorService.submitted$.next(this.submitted);
        this.isClosing = false;
        this.isSaving = false;
        return;
      }
      if (this.id) {
        this.model.Numbers[0].State = RowState.Modify;
        this.model.Numbers[0].IsDefault = false;
        const numberRow: CustomerContactNumber = JSON.parse(JSON.stringify(this.model.Numbers[0]));
        numberRow.IsDefault = true;
        numberRow.Id = 0;
        numberRow.State = RowState.New;
        numberRow.Number = phoneNumber;
        this.model.Numbers.push(numberRow);
      }
      if (phoneNumber) {
        this.httpCommonService
          .getList(`Customer/ReadCustomerByMobile/${phoneNumber}`)
          .pipe(take(1))
          .subscribe((customer: Customer) => {
            if (customer) {
              this.sts.showDialog(
                `${this.translate("ClientApp.FrontOffice.Parties.Customer.DesiredSubscriberPhoneNumberAlreadyEntered")}
                ${customer.DisplayName} - ${this.translate("ClientApp.FrontOffice.Parties.Customer.SubscriptionCode")}:${customer.Number}`,
                this.translate("ClientApp.FrontOffice.Parties.Customer.CustomerReplacement"),
                DialogType.confirm,
                () => this.reloadCustomer(customer),
                () => {
                  this.selectorService.submitted$.next(false);
                }
              );
            } else {
              this.save();
            }
          });
      }
    } else {
      this.save();
    }
  }
  reloadCustomer(customer: Customer) {
    this.model = customer;
    this.currentrow = this.model;
    this.isNewRow = false;
    this.id = customer.Id;
    this.setValue("PartyId", this.model.PartyId);
    this.formGroup.controls["Id"].setValue(this.id);
    this.addCustomerFormGroup();
    this.save();
  }
  setdefault() {
    if (this.model.Number === 0) this.DeactiveHasCreate = true;
    if (this.model.Addresses && this.model.Addresses.length > 0 && this.zonesLookup?.length > 0) this.setAddressesInfo();

    if (this.zonesLookup.length === 1 || this.hasClubCustomer || this.currentrow?.hasAddFastCustomer) {
      const defaultZone = this.zonesLookup.find((x) => x.Code === 0);
      if (defaultZone && this.model && !this.model.Id) {
        this.model.ZoneId = defaultZone.Id;
        this.setValue("ZoneId", defaultZone.Id);
        this.model.Address = defaultZone.Title;
        this.setValue("Address", defaultZone.Title);
      }
    }

    // from order online
    this.setValuesForOrderOnline();

    const a = this.columns?.find((element) => element.name === "Addresses");
    if (a && a.DetailControlModels) a.DetailControlModels.Addresses.find((a) => a.name === "CourierShippingCost").disabled = true;

    if (!this.model.Addresses) this.model.Addresses = [];
    if (!this.model.Numbers) this.model.Numbers = [];
    if (!this.model.Occasions) this.model.Occasions = [];

    if (this.model && !this.model.Id) {
      //اگر در مد ایجاد بودیم
      if (!this.currentInformation.RestaurantCallCenter) this.model.IsActive = true;

      if (this.customerCategories && this.customerCategories.length === 1) {
        this.model.CategoryId = this.customerCategories[0].Id;
        this.setValue("CategoryId", this.model.CategoryId);
      }

      if (!this.model.Party) {
        this.model.Party = new Party(); // Ensure Party is initialized
      }

      if (!this.model.Party?.PersonalityKindId) {
        this.lookupService
          .getLookupbyCode("GNR", "PersonalityKind", PersonalityKindEnum.Realperson)
          .pipe(take(1))
          .subscribe((x) => {
            if (this.model && this.model.Party) {
              this.model.Party.PersonalityKindId = x.Id;
              this.model.Party.PersonalityKindTitle = x.Title;
              this.model.Party.PersonalityKindCode = x.Code;
              this.setValue("PersonalityKindId", x.Id);
              this.setValue("PersonalityKindTitle", x.Title);
              this.setValue("PersonalityKindCode", x.Code);
            }
          });
      }
      if (this.model && !this.model.GenderId) {
        this.lookupService
          .getLookupbyCode("GNR", "Gender", GenderEnum.Male)
          .pipe(take(1))
          .subscribe((x) => {
            this.model.GenderId = x.Id;
            this.model.GenderTitle = x.Title;
            this.setValue("GenderId", x.Id);
            this.setValue("GenderTitle", x.Title);
          });
      } else this.setValue("GenderId", this.model.GenderId);

      if (this.model && !this.model.CreditControlTypeId) {
        this.lookupService
          .getLookupbyCode("SALE", "CreditControlType", CreditControlType.Warning)
          .pipe(take(1))
          .subscribe((x) => {
            this.model.CreditControlTypeId = x.Id;
            this.model.CreditControlTypeTitle = x.Title;
            this.setValue("CreditControlTypeId", x.Id);
            this.setValue("CreditControlTypeTitle", x.Title);
          });
      }
      if (this.model && !this.model.CreditControlTypeId) {
        this.lookupService
          .getLookupbyCode("SALE", "CreditControlType", CreditControlType.Warning)
          .pipe(take(1))
          .subscribe((x) => {
            this.model.CreditControlTypeId = x.Id;
            this.model.CreditControlTypeTitle = x.Title;
            this.setValue("CreditControlTypeId", x.Id);
            this.setValue("CreditControlTypeTitle", x.Title);
          });
      }
    }

    if (this.model && this.model.PartyId) {
      //اگر در مد ویرایش بودیم
      if (this.formGroup && this.formGroup.controls["PartyId"]) this.formGroup.controls["PartyId"]?.disable();
      if (this.formGroup && this.formGroup.controls["Number"]) this.formGroup.controls["Number"]?.disable();
      if (this.formGroup && this.model.Party?.PersonalityKindCode == this.personalityKindEnum.Legalperson) {
        this.hasLegalCustomer = true;
      }
      if (this.model.PartyId) {
        if (this.formGroup && this.formGroup.controls["FirstName"]) this.formGroup.controls["FirstName"]?.disable();
        if (this.formGroup && this.formGroup.controls["LastName"]) this.formGroup.controls["LastName"]?.disable();
      }
    }
    setTimeout(() => {
      if (this.currentrow?.Id && this.model?.Addresses?.length > 0 && this.BranchLookUp?.length > 0 && this.currentInformation.RestaurantCallCenter) {
        this.setDefaultBranchId();
      }
    }, 2000);

    setTimeout(() => {
      if (this.currentrow?.Id && this.model?.Addresses?.length > 0 && this.BranchLookUp?.length > 0 && this.currentInformation.RestaurantCallCenter) {
        this.setDefaultBranchId();
      }
      if (this.model?.Addresses?.length > 0) {
        this.model?.Addresses?.forEach((f) => {
          if (!f.DefaultBranchId && f.Zone?.Branches?.some((s) => s.IsDefault)) {
            f.DefaultBranchId = f.Zone.Branches.find((s) => s.IsDefault).BranchId;
            f.DefaultBranchTitle = this.BranchLookUp?.find((s) => s.Id === f.DefaultBranchId)?.Title;
          } else {
            if (f.DefaultBranchId) {
              f.DefaultBranchTitle = this.BranchLookUp?.find((s) => s.Id === f.DefaultBranchId)?.Title;
            }
          }
        });
      }
      this.showAddressGrid = true;
    }, 150);
  }

  setAddressesInfo() {
    for (var i = 0; i < this.model.Addresses.length; i++) {
      const address = this.model.Addresses[i];
      const branchId = address?.DefaultBranchId || address?.Zone?.Branches?.find((f) => f.IsDefault)?.BranchId || this.currentBranch.Id;
      if (!address.ShippingCost) {
        address.ShippingCost = address.Zone.Branches.find((x) => x.BranchId === branchId)?.ShippingCost;
      }
      if (!address.CourierShippingCost) {
        address.CourierShippingCost = address.Zone.Branches.find((x) => x.BranchId === branchId)?.CourierShippingCost;
      }
      if (address.IsDefault) {
        this.setValue("CourierShippingCost", address.CourierShippingCost);
        this.setValue("ShippingCost", address.ShippingCost);
        this.model.ShippingCost = address.ShippingCost;
        this.model.CourierShippingCost = address.CourierShippingCost;
        this.oldGridShippingCost = address.ShippingCost;
      }
    }
  }

  PartyAccountChange(event) {
    const controls = this.formGroup.controls;
    if (!event) {
      controls["FirstName"].enable();
      controls["LastName"].enable();
      controls["Number"].enable();
    }
    if (event && event.Number && event.LastName) {
      this.model.Number = event.Number;
      controls["Number"].setValue(event.Number);
      this.model.FirstName = event.FirstName;
      controls["FirstName"].setValue(event.FirstName);
      this.model.LastName = event.LastName;
      controls["LastName"].setValue(event.LastName);
      this.model.Description = event.Description;
      controls["Description"].setValue(event.Description);
      this.model.PhoneNumber = event.MobileNumber;
      controls["PhoneNumber"].setValue(event.MobileNumber);
      this.model.Address = event.Address;
      controls["Address"].setValue(event.Address);
      if (this.model.Party) {
        this.model.Party.DetailLedgerId = event.DetailLedgerId;
      }
      this.setValue("DetailLedgerId", event.DetailLedgerId);

      controls["Number"].disable();
      controls["LastName"].disable();
      if (controls["FirstName"].value) controls["FirstName"].disable();
    }
    setTimeout(() => {
      const input: HTMLInputElement = document.getElementById("Description") as HTMLInputElement;
      if (input) input.focus();
    }, 100);
  }
  setHeaderInfo() {
    const controls = this.formGroup.controls;
    let phoneNumber = controls["PhoneNumber"].value;
    let numberTypeId = controls["NumberTypeId"].value;
    let haveNumbersItem = false;
    let haveIsDefaultNumber = false;
    if (this.model.Numbers) {
      haveNumbersItem = this.model.Numbers.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
      haveIsDefaultNumber = this.model.Numbers?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).some((a) => a.IsDefault);
    }
    if (
      phoneNumber &&
      numberTypeId &&
      (this.model.PhoneNumber != phoneNumber || this.model.NumberTypeId != numberTypeId || !haveNumbersItem || !haveIsDefaultNumber)
    ) {
      let findIndex = this.model.Numbers?.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).findIndex(
        (x) => x.NumberTypeId === numberTypeId && x.Number === phoneNumber && !x.IsDefault
      );
      if (findIndex === -1) {
        let number: CustomerContactNumber = <CustomerContactNumber>{};
        number.State = RowState.New;
        number.IsDefault = true;
        number.NumberTypeId = numberTypeId;
        number.Number = phoneNumber;
        if (!this.model.Numbers) {
          this.model.Numbers = [];
          this.model.Numbers.push(number);
        } else {
          let isFound: boolean = false;
          this.model.Numbers?.filter((x) => x.State != RowState.Detached).forEach((x) => {
            if (x.IsDefault === true && (!this.hasClubCustomer || !this.id)) {
              isFound = true;
              x.NumberTypeId = numberTypeId;
              x.Number = phoneNumber;
              if (x.State != RowState.New) {
                x.State = RowState.Modify;
                this.model.State = RowState.Modify;
              }
            }
          });
          if (!isFound) {
            if (!this.model.Numbers?.find((x) => x.IsDefault)) {
              this.model.Numbers.push(number);
            }
          }
        }
      } else {
        this.model.Numbers.forEach((x) => (x.IsDefault = false));
        this.model.Numbers[findIndex].IsDefault = true;
      }
    }

    let zoneId = controls["ZoneId"].value;
    let address = controls["Address"].value;
    let branchId = controls["DefaultBranches"]?.value;
    let haveAddressesItem = false;
    let haveIsDefaultAddress = false;
    if (this.model.Addresses) {
      haveAddressesItem = this.model.Addresses.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
      haveIsDefaultAddress = this.model.Addresses.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).some(
        (a) => a.IsDefault
      );
    }
    if (zoneId && address && (this.model.ZoneId != zoneId || this.model.Address != address || !haveAddressesItem || !haveIsDefaultAddress)) {
      let findIndex = this.model.Addresses.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).findIndex(
        (x) => x.ZoneId === zoneId && x.Address === address && !x.IsDefault
      );
      if (findIndex === -1) {
        let defaultAddress: CustomerAddress = <CustomerAddress>{};
        defaultAddress.State = RowState.New;
        defaultAddress.IsDefault = true;
        defaultAddress.ZoneId = zoneId;
        defaultAddress.Address = address;
        defaultAddress.DefaultBranchId = branchId;
        if (this.model.Addresses === null || !(this.model.Addresses.length > 0)) {
          this.model.Addresses = [];
          this.model.Addresses.push(defaultAddress);
        } else {
          let isFound: boolean = false;
          this.model.Addresses?.filter((x) => x.State != RowState.Detached).forEach((x) => {
            if (x.IsDefault === true) {
              isFound = true;
              x.ZoneId = zoneId;
              x.Address = address;
              if (x.State !== RowState.New) {
                x.State = RowState.Modify;
              }
            }
          });
          if (!isFound) {
            this.model.Addresses.push(defaultAddress);
          }
        }
      } else {
        this.model.Addresses.forEach((x) => (x.IsDefault = false));
        this.model.Addresses[findIndex].IsDefault = true;
      }
    }
    this.model?.Addresses?.forEach((ele) => {
      if (ele?.Zone?.ShippingCost !== controls["ShippingCost"]?.value && ele?.IsDefault) {
        ele.ShippingCost = controls["ShippingCost"].value;
        ele.State = ele.Id == 0 ? RowState.New : RowState.Modify;
      }
    });
  }
  isValid(): boolean {
    this.setHeaderInfo();
    this.erroremessage = "";
    this.haserror = false;
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.invalid) {
      this.haserror = true;
      for (const ctrlName in this.formGroup.controls) {
        const element = this.formGroup.controls[ctrlName];
        if (element.errors) {
          const title = this.orignalColumns.find((x) => x.name === ctrlName)?.label;
          if (element.errors.pattern) {
            this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.for") + ` ${title} ` + this.translate("Errors.Pattern");
          } else
            this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.Amount") + ` ${title} ` + this.translate("Errors.Required");
          break;
        }
      }
    }
    if (this.model.Addresses && this.model.Addresses.length > 0) {
      this.model.Addresses = this.model.Addresses.filter((x) => x.State != RowState.Detached);
    }
    if (this.formGroup?.valid && !this.formGroup.controls["IsActive"].value && !this.formGroup.controls["DeactivationReason"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.CompletingCauseDeactivationRequired");
    }
    if (this.model.Numbers && this.model.Numbers.length > 0) {
      this.model.Numbers = this.model.Numbers.filter((x) => x.State != RowState.Detached);
    } else if (!this.model.Numbers || this.model.Numbers.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length <= 0) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.NecessaryTelephone");
    } else if (this.hasCredit) {
      if (!this.formGroup.controls["CreditControlTypeId"].value) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.ChoosingCreditControlMethod");
      }
    } else if (!this.formGroup.controls["CategoryId"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.CustomerGroupSelectionRequired");
    } else if (!this.formGroup.controls["LastName"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.ChoosingLastNameMandatory");
    } else if (!this.formGroup.controls["ZoneId"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.ChoosingNeighborhoodMandatory");
    } else if (!this.formGroup.controls["Address"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.AtLeastOneAddressRequired");
    } else if (!this.formGroup.controls["PersonalityKindId"].value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Customer.CustomerTypeValueNotEntered");
    }
    if (this.formGroup.controls["PercentDiscount"].value > 100) {
      this.setValue("PercentDiscount", 100);
    }
    if (this.model?.Party?.PersonalityKindCode == PersonalityKindEnum.Legalperson) {
      if (!this.formGroup.controls["PostalCode"].value) {
        this.sts.showToast(
          "warning",
          this.translate("ClientApp.FrontOffice.Parties.Customer.Attention"),
          this.translate("ClientApp.FrontOffice.Parties.Customer.ZipCodeNotEntered")
        );
        return false;
      }
      if (this.formGroup.controls["PostalCode"].value && this.formGroup.controls["PostalCode"].value > 9999999999) {
        this.sts.showToast(
          "warning",
          this.translate("ClientApp.FrontOffice.Parties.Customer.Attention"),
          this.translate("ClientApp.FrontOffice.Parties.Customer.ZipCodeFieldLengthValueNotCorrect")
        );
        return false;
      }
    }
    if (this.formGroup.controls["NationalCode"].value && this.formGroup.controls["NationalCode"].value.length > 10000000000) {
      this.sts.showToast(
        "warning",
        this.translate("ClientApp.FrontOffice.Parties.Customer.Attention"),
        this.translate("ClientApp.FrontOffice.Parties.Customer.LengthValueNationalNumberFieldNotAppropriate")
      );
      return false;
    }
    if (this.formGroup.controls["NationalId"].value && this.formGroup.controls["NationalId"].value.length > 1000000000000000) {
      this.sts.showToast(
        "warning",
        this.translate("ClientApp.FrontOffice.Parties.Customer.Attention"),
        this.translate("ClientApp.FrontOffice.Parties.Customer.NationalIDFieldLengthValueAppropriate")
      );
      return false;
    }
    if (!this.haserror) this.checkByPersonalityKindValidation();

    return !this.haserror;
  }

  protected saveFailedHelper(error: any) {
    this.submitted = false;
    this.selectorService.submitted$.next(this.submitted);
    this.isClosing = false;
    this.isSaving = false;
    const message: any = Utilities.getHttpResponseMessage(error);
    const messageStr = message.toString(); // or String(message)
    this.sts.showToast(
      "danger",
      this.translate("ClientApp.FrontOffice.Parties.Customer.SaveError"),
      `${this.translate("ClientApp.FrontOffice.Parties.Customer.ErrorSavingChanges")}: ${message}`
    );
    this.sts.showDialog(
      `${this.translate("ClientApp.FrontOffice.Parties.Customer.ErrorSavingChanges")}: ${message}`,
      this.translate("ClientApp.FrontOffice.Parties.Customer.ErrorMessage")
    );
    const regex = /کد جدید (\d+) جایگذاری/;
    const found = messageStr.match(regex);
    if (found) {
      const value = found[1];
      this.model.Number = +value;
      this.setValue("Number", +value);
    }
    if (this.changesFailedCallback) this.changesFailedCallback();
    this.saveHasError();
  }

  valueChange($event) {
    if (this.formGroup.controls["PercentDiscount"].value > 100) {
      this.setValue("PercentDiscount", 100);
    }
  }
  setMaxCode() {
    if (this.isFindCustomer) return;
    if (!this.currentrow?.Id) {
      this.httpCommonService
        .get(this.apiName + "/GetCustomerMaxCode")
        .pipe(take(1))
        .subscribe((data: MaxCodeViewModel) => {
          if (data.HaspreFix) {
            this.formGroup.controls["Number"].disable();
            this.disableNumber = true;
          } else {
            this.formGroup.controls["Number"].enable();
            this.disableNumber = false;
          }
          if (!this.model) this.model = <Customer>{};
          if (data) this.model["Number"] = data.MaxCode;
          this.setFormGroup(this.model);
        });
    }
  }

  addControl() {
    if (this.formGroup) {
      this.setValue("ShippingCost", this.model.ShippingCost);
      this.setValue("PartyId", this.model.PartyId);
      this.setValue("DisplayName", this.model.DisplayName);
      this.setValue("ZoneId", this.model.ZoneId);
      this.formGroup.controls["ZoneId"].setValidators([Validators.required]);
      this.setValue("IsActive", this.model.IsActive != null ? this.model.IsActive : true);
      this.setValue("DeactivationReason", this.model.DeactivationReason);
      this.setValue("HasCredit", this.model.HasCredit);
      this.setValue("CreditControlTypeId", this.model.CreditControlTypeId);
      this.setValue("CreditLimit", this.model.CreditLimit);
      this.setValue("AutomaticDebtor", this.model.AutomaticDebtor);
      this.setValue("PersonalityKindId", this.model.Party?.PersonalityKindId);
      this.formGroup.controls["PersonalityKindId"].setValidators([Validators.required]);
      this.setValue("GenderId", this.model.GenderId);
      this.formGroup.controls["GenderId"].setValidators([Validators.required]);
      this.setValue("CourierShippingCost", this.model.CourierShippingCost);
      this.setValue("CategoryId", this.model.CategoryId, true);
      this.setValue("PercentDiscount", this.model.PercentDiscount);
      this.setValue("DefaultBranches", this.model.DefaultBranches);
      this.setValue("FailurePaymentLink", this.model.FailurePaymentLink);
      this.setValue("DetailLedgerId", this.model.Party?.DetailLedgerId);
      this.setValue("SubLedgerId", this.model.Party?.SubLedgerId);
      this.setValue("NationalCode", this.model.Party?.NationalCode, false, this.nationalCodePattern);
      this.setValue("NationalId", this.model.Party?.NationalId, false, this.nationalIdPattern);
      this.setValue("EconomicCode", this.model.EconomicCode);
      this.setValue("RegistrationNumber", this.model.RegistrationNumber);
      this.setValue("RegistrationDate", this.model.RegistrationDate);
      this.setValue("CreatedUserTitle", this.model.CreatedUserTitle);
      this.setValue("ModifiedUserTitle", this.model.ModifiedUserTitle);
      this.setValue("PostalCode", this.model.PostalCode);

      this.hasCredit = this.model?.HasCredit;
    }
    const defaultAddress = this.model?.Addresses?.find((f) => f.IsDefault);
    if (defaultAddress) {
      let shippingCost = 0;
      if (!defaultAddress?.ShippingCost && (defaultAddress.ShippingCost === null || defaultAddress.ShippingCost === undefined)) {
        shippingCost = defaultAddress.Zone?.ShippingCost;
      } else if (typeof defaultAddress?.ShippingCost === "number") shippingCost = defaultAddress?.ShippingCost;

      this.model.ShippingCost = shippingCost;
    }
    if (this.CallerIdNumber) {
      this.model.PhoneNumber = this.CallerIdNumber ? (this.CallerIdNumber?.length >= 9 ? '0' + this.CallerIdNumber : this.CallerIdNumber )  : this.model.PhoneNumber;
      this.setValue("PhoneNumber", this.model.PhoneNumber);
    }
    if (this.zonesLookup && this.zonesLookup.length === 1) {
      const defaultZone = this.zonesLookup.find((x) => x.Code === 0);
      if (defaultZone) {
        this.model.ZoneId = defaultZone.Id;
        this.setValue("ZoneId", defaultZone.Id);
      }
      if (this.CallerIdNumber?.startsWith("09")) {
        this.lookupService
          .getLookupbyCode("SALE", "NumberType", NumberType.Mobile)
          .pipe(take(1))
          .subscribe((x) => {
            this.model.NumberTypeId = x.Id;
            this.setValue("NumberTypeId", x.Id);
          });
      } else {
        this.lookupService
          .getLookupbyCode("SALE", "NumberType", NumberType.Phone)
          .pipe(take(1))
          .subscribe((x) => {
            this.model.NumberTypeId = x.Id;
            this.setValue("NumberTypeId", x.Id);
          });
      }
    } else {
      if (this.model && this.model.Numbers != null && this.model.Numbers.some((x) => x.IsDefault)) {
        let numberTypeCode = this.model.Numbers.find((x) => x.IsDefault).NumberTypeCode;
        if (numberTypeCode > 0) {
          this.setPatternKey(numberTypeCode);
        }
      }
    }
    if (defaultAddress?.Zone?.ShippingCost !== this.formGroup.controls["ShippingCost"].value) {
      this.model.Addresses.forEach((e) => {
        if (e.IsDefault) {
          e.ShippingCost = defaultAddress?.ShippingCost;
          e.State = RowState.Modify;
        }
      });
    }
    if (this.currentrow?.hasAddFastCustomer) {
      if (!this.showDefaultBranch) this.formGroup.controls["ZoneId"].setValue(this.zonesLookup?.find((x) => x.Code === 0)?.Id);
      if (!this.currentBranch.AccessToAllBranches) this.formGroup.controls["DefaultBranches"].setValue(this.currentBranch.Id);
      else this.formGroup.controls["DefaultBranches"].setValue(null);
      this.formGroup.controls["PersonalityKindId"].setValue(this.PersonalityKindLookup?.find((x) => x.Code === PersonalityKindEnum.Realperson)?.Id);
      this.formGroup.controls["CategoryId"].setValue(this.customerCategories?.find((x) => x.Code === 0)?.Id);
      this.formGroup.controls["GenderId"].setValue(this.GenderLookup?.find((x) => x.Code === GenderEnum.Male)?.Id);
    } else if (this.hasClubCustomer) {
      const defaultZone = this.zonesLookup?.find((x) => x.Code === 0);
      if (this.nameIsNotNecessary) {
        this.formGroup.controls["ZoneId"].setValue(defaultZone?.Id);
        this.formGroup.controls["Address"].setValue(defaultZone.Title);
        this.formGroup.controls["LastName"].setValue(this.LastName);
      }
      if (!this.currentBranch.AccessToAllBranches) this.formGroup.controls["DefaultBranches"].setValue(this.currentBranch.Id);
      else this.formGroup.controls["DefaultBranches"].setValue(null);
      this.formGroup.controls["PersonalityKindId"].setValue(this.PersonalityKindLookup?.find((x) => x.Code === PersonalityKindEnum.Realperson)?.Id);
      this.formGroup.controls["CategoryId"].setValue(this.customerCategories?.find((x) => x.Code === 0)?.Id);
      this.formGroup.controls["GenderId"].setValue(this.GenderLookup?.find((x) => x.Code === GenderEnum.Male)?.Id);
    } else this.cd.markForCheck();
    if (this.model.Party?.PersonalityKindId) this.checkByPersonalityKindValidation();
    this.controlsIsAdded = true;
    this.cd.markForCheck();
  }

  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  beforupdate() {
    this.isValid();
    if (this.model.Party) {
      this.model.Party.PersonalityKindId = this.formGroup.controls["PersonalityKindId"].value;
      this.model.Party.NationalId = this.formGroup.controls["NationalId"].value;
      this.model.Party.NationalCode = this.formGroup.controls["NationalCode"].value;
      this.model.Party.SubLedgerId = this.formGroup.controls["SubLedgerId"].value;
      this.model.Party.DetailLedgerId = this.formGroup.controls["DetailLedgerId"].value;
    }
    if (this.formGroup.controls["PartyId"].value === null) {
      this.formGroup.controls["PartyId"].setValue(0);
    }
    if (this.formGroup.controls["PhoneNumber"].value === null) {
      this.formGroup.controls["PhoneNumber"].setValue(undefined);
    }

    if (this.formGroup.controls["HasCredit"].value === false) {
      this.formGroup.controls["CreditControlTypeId"].setValue(null);
      this.formGroup.controls["CreditLimit"].setValue(null);
      this.formGroup.controls["AutomaticDebtor"].setValue(false);
    }
    if (this.formGroup.controls["IsActive"].value === true) {
      this.formGroup.controls["DeactivationReason"].setValue("");
    }

    this.model.PercentDiscount = this.formGroup.controls["PercentDiscount"].value;
    this.completeAddressGridValue();
    this.completePhoneNumberGridValue();
  }

  afterSaveAddressRow(entity: CustomerAddress) {
    if (!!entity.IsDefault) {
      const { ShippingCost, ZoneId, DefaultBranchId, Address } = entity;
      if (this.gridShippingCostHasChanged) {
        this.model.ShippingCost = ShippingCost;
        this.setValue("ShippingCost", this.model.ShippingCost);
      }
      this.model.ZoneId = ZoneId;
      this.model.DefaultBranches = DefaultBranchId;
      this.model.Address = Address;
      this.setValue("ZoneId", this.model.ZoneId);
      this.setValue("DefaultBranches", this.model.DefaultBranches);
      this.setValue("Address", this.model.Address);
      this.cd.markForCheck();
    }
  }

  onShippingCostChanges() {
    const defaultAddress = this.model?.Addresses?.find((f) => f.IsDefault);
    if (defaultAddress) {
      defaultAddress.ShippingCost = this.formGroup.controls["ShippingCost"]?.value;
    }
  }

  onBranchChanges(branchId: number, IsDefaultRow?: boolean, gridFormGroup?: FormGroup) {
    if (!branchId) {
      gridFormGroup?.controls["ShippingCost"].setValue(null);
      gridFormGroup?.controls["CourierShippingCost"].setValue(null);
      const currentAddress = this.model.Addresses.find((x) => x.Order === gridFormGroup?.controls["Order"]?.value);
      if (currentAddress) currentAddress.CourierShippingCost = null;
      if (IsDefaultRow) {
        this.model.ShippingCost = null;
        this.model.CourierShippingCost = null;
        this.setValue("ShippingCost", null);
        this.setValue("CourierShippingCost", null);
        this.setValue("DefaultBranches", null);
      }
      return;
    }
    const zoneId = gridFormGroup ? gridFormGroup.controls["ZoneId"].value : this.formGroup.controls["ZoneId"].value;
    const selectedZone = this.zonesLookup.find((x) => x.Id === zoneId);
    const branchInfo = selectedZone?.Branches.find((x) => x.BranchId === branchId);
    if (branchInfo) {
      if (IsDefaultRow) {
        this.model.ShippingCost = branchInfo.ShippingCost;
        this.model.CourierShippingCost = branchInfo.CourierShippingCost;
        this.setValue("ShippingCost", this.model.ShippingCost);
        this.setValue("CourierShippingCost", this.model.CourierShippingCost);
        this.setValue("DefaultBranches", branchId);
        if (gridFormGroup) {
          gridFormGroup.controls["ShippingCost"].setValue(branchInfo.ShippingCost);
          gridFormGroup.controls["CourierShippingCost"].setValue(branchInfo.CourierShippingCost);
        } else {
          const defaultAddress = this.model.Addresses.find((x) => x.IsDefault);
          if (defaultAddress) {
            defaultAddress.CourierShippingCost = branchInfo.CourierShippingCost;
            defaultAddress.ShippingCost = branchInfo.ShippingCost;
            defaultAddress.DefaultBranchId = branchId;
            const branchTitle = this.BranchLookUp?.find((x) => x.Id === branchId)?.Title;
            defaultAddress.DefaultBranchTitle = branchTitle;
            if (this.model?.Id) {
              defaultAddress.State = RowState.Modify;
            }
          }
        }
      } else {
        gridFormGroup?.controls["ShippingCost"].setValue(branchInfo.ShippingCost);
        gridFormGroup?.controls["CourierShippingCost"].setValue(branchInfo.CourierShippingCost);
      }
    }
  }

  valueChangeByApiName($event) {
    if ($event.data && $event.data.Category === "NumberType") {
      this.setPatternKey($event.data.Code);
    }
  }
  //مقدار دهی کرایه وکرایه سهم پیک با تغییر محله
  ZoneIdChange(headerEvent: any, gridEvent: FormGroup) {
    if (!gridEvent) {
      this.selectedZoneId = headerEvent?.Id;
      if (!this.formGroup.controls["Address"].value) this.setValue("Address", headerEvent?.Title);
      if (this.formGroup.dirty) {
        this.cd.markForCheck();
        setTimeout(() => {
          const input: HTMLInputElement = document.getElementById("Address") as HTMLInputElement;
          if (input) input.focus();
        }, 10);
      }
      if (headerEvent) {
        this.selectedZone = headerEvent;
        this.setValue("ShippingCost", headerEvent.ShippingCost);
        this.setValue("CourierShippingCost", headerEvent.CourierShippingCost);
        if (!this.formGroup.controls["Address"].value) this.setValue("Address", headerEvent.Title);
        if (this.BranchLookUp?.find((x) => x.Id === headerEvent?.DefaultId)?.IsActive) {
          this.model.DefaultBranches = headerEvent?.DefaultId;
          this.setValue("DefaultBranches", this.model.DefaultBranches);
          this.model?.Addresses?.map((address) => {
            if (address.IsDefault) address.DefaultBranchId = this.model.DefaultBranches;
          });
        } else {
          this.model.DefaultBranches = null;
          this.setValue("DefaultBranches", null);
        }
        this.cd.markForCheck();
      }
    } else {
      const zoneId = gridEvent.controls["ZoneId"].value;
      const selectedZone = this.zonesLookup?.find((x) => x.Id === zoneId);
      const branchId = selectedZone?.Branches?.find((f) => f.BranchId === selectedZone?.DefaultId)?.BranchId;
      gridEvent.controls["DefaultBranchId"].setValue(branchId ?? null, { emitEvent: false });
      const IsDefault = gridEvent.controls["IsDefault"]?.value;
      this.onBranchChanges(branchId, IsDefault, gridEvent);
      gridEvent.controls["Address"].setValue(selectedZone?.Title);
      gridEvent.controls["ShippingCost"].setValue(selectedZone?.ShippingCost);
      gridEvent.controls["CourierShippingCost"].setValue(selectedZone?.CourierShippingCost);
    }
    this.cd.detectChanges();
  }
  setPatternKey(Code: number) {
    let patternKey = "^[1-9]\\d{3,7}";
    if (Code === NumberType.Mobile) {
      patternKey = "^[0-0][9-9]\\d{9}";
    }
    this.orignalColumns.forEach((x) => {
      if (x.name === "PhoneNumber") x.patternKey = patternKey;
    });
    if (this.formGroup.controls["PhoneNumber"]) {
      this.formGroup.controls["PhoneNumber"].clearValidators();
      this.formGroup.controls["PhoneNumber"].setErrors(null);
      this.formGroup.controls["PhoneNumber"].setValidators([Validators.required, Validators.pattern(patternKey)]);
      this.formGroup.controls["PhoneNumber"].setValue(this.formGroup.controls["PhoneNumber"].value);
      this.formGroup.markAsDirty();
      this.formGroup.markAsTouched();
      this.cd.markForCheck();
    }
  }

  onPhoneNumberChanges(number: string) {
    if (number.length == 2) {
      if (number.startsWith("09")) {
        this.lookupService
          .getLookupbyCode("SALE", "NumberType", NumberType.Mobile)
          .pipe(take(1))
          .subscribe((x) => {
            this.model.NumberTypeId = x.Id;
            this.setValue("NumberTypeId", x.Id);
            this.setPatternKey(x.Code);
          });
      } else {
        this.lookupService
          .getLookupbyCode("SALE", "NumberType", NumberType.Phone)
          .pipe(take(1))
          .subscribe((x) => {
            this.model.NumberTypeId = x.Id;
            this.setValue("NumberTypeId", x.Id);
            this.setPatternKey(x.Code);
          });
      }
    } else if (number.length > 13) {
      if (number.startsWith("09")) {
        number = number.substring(0, 13);
        this.formGroup.controls["PhoneNumber"].setValue(number);
      }
    }
  }

  getByPhoneNumber() {
    let phoneNumber = this.formGroup.controls["PhoneNumber"].value;

    this.httpCommonService
      .get("Customer/ReadCustomerByMobile/" + phoneNumber)
      .pipe(take(1))
      .subscribe((customer: Customer) => {
        if (customer.Number !== 0) {
          return;
        } else {
          this.Customer = customer;
          this.setValue("LastName", this.Customer?.LastName);
          this.setValue("Address", this.Customer.Address);
          this.setValue("ZoneId", this.Customer.ZoneId);
          this.setValue("GenderId", this.Customer.GenderId);
        }
      });
  }

  CreditCourierChange(event) {
    this.hasCredit = event;
    setTimeout(() => this.cd.markForCheck(), 50);
  }
  PersonalityKindChange($event) {
    this.model.Party.PersonalityKindCode = $event.Code;
    this.formGroup.controls["NationalId"].setValue("");
    this.formGroup.controls["NationalCode"].setValue("");
    this.checkByPersonalityKindValidation();
  }
  afterupdate() {}
  valueChanges(formGroup: FormGroup) {
    if (
      formGroup &&
      formGroup.controls &&
      formGroup.controls["IsDefault"]?.value &&
      this.oldGridShippingCost !== formGroup.controls["ShippingCost"]?.value
    ) {
      this.oldGridShippingCost = formGroup.controls["ShippingCost"]?.value;
      this.gridShippingCostHasChanged = true;
    }
  }

  onAddressFormGroupValueChanges(changedData: { newValue: any; oldValue: any; field: string; formGroup: FormGroup }) {
    if (changedData.field === "DefaultBranchId") {
      const IsDefault = changedData.formGroup.controls["IsDefault"]?.value;
      this.onBranchChanges(changedData.newValue, IsDefault, changedData.formGroup);
    }
    if (changedData.field === "ZoneId") {
      this.ZoneIdChange(null, changedData.formGroup);
    }
  }

  onPhoneListFormGroupValueChanges(changedData: { newValue: any; oldValue: any; field: string; formGroup: FormGroup }) {
    const IsDefault = changedData?.formGroup?.controls["IsDefault"]?.value;
    if (changedData.field === "NumberTypeId" && IsDefault) {
      this.model.NumberTypeId = changedData.newValue;
      this.setValue("NumberTypeId", changedData.newValue);
    }
    if (changedData.field === "Number") {
      this.telephoneListGridEl.setPhoneValidators(changedData.formGroup?.controls["IsDefault"]?.value?.NumberTypeCode);
      if (IsDefault) {
        this.model.PhoneNumber = changedData.newValue;
        this.setValue("PhoneNumber", changedData.newValue);
        this.setPatternKey(changedData.formGroup.controls["NumberTypeCode"].value);
      }
    }
    if (changedData.field === "IsDefault") {
      this.telephoneListGridEl.setPhoneValidators(changedData.formGroup?.controls["IsDefault"]?.value?.NumberTypeCode);
      this.model.PhoneNumber = changedData.newValue;
      this.setValue("PhoneNumber", changedData.formGroup.controls["Number"].value);
      this.setValue("NumberTypeId", changedData.formGroup.controls["NumberTypeId"].value);
      this.setPatternKey(changedData.formGroup.controls["NumberTypeCode"].value);
    }
  }

  showMapDialog() {
    const confirmValue = new Subject();
    const defaultAddress = this.model?.Addresses?.find((f) => f.IsDefault);
    confirmValue.pipe(take(1)).subscribe((value: MapConfirmValue) => {
      if (!defaultAddress) {
        let dA: CustomerAddress = <CustomerAddress>{};
        dA.State = RowState.New;
        dA.IsDefault = true;
        dA.ZoneId = this.model.ZoneId;
        dA.Address = value.formattedAddress;
        dA.DefaultBranchId = this.model.BranchId;
        dA.Longitude = value.lng;
        dA.Latitude = value.lat;
        this.model.Addresses.push(dA);
        this.setValue("Address", value.formattedAddress);
      } else {
        defaultAddress.Longitude = value.lng;
        defaultAddress.Latitude = value.lat;
        defaultAddress.State = RowState.Modify;
      }
    });
    this.dialogService.open(
      MapComponent,
      { confirmValue, lat: defaultAddress?.Latitude, lng: defaultAddress?.Longitude, formattedAddress: this.formGroup.controls["Address"].value },
      { autoFocus: true, closeOnClickOutside: true }
    );
  }

  onAddressGridRowSelected(row: CustomerAddress) {
    if (row.Id == 0) row.Id = Math.floor(Math.random() * 10000000);
    this.currentAddressGridRow = row;
  }

  editLocation() {
    const confirmValue = new Subject();
    const relatedAddress = this.model?.Addresses?.find((f) => f.Id === this.currentAddressGridRow.Id);
    if (relatedAddress) {
      confirmValue.pipe(take(1)).subscribe((value: MapConfirmValue) => {
        relatedAddress.Longitude = value.lng;
        relatedAddress.Latitude = value.lat;
        relatedAddress.State = RowState.Modify;
      });
      this.dialogService.open(
        MapComponent,
        { confirmValue, lat: relatedAddress.Latitude, lng: relatedAddress.Longitude, formattedAddress: relatedAddress.Address },
        { autoFocus: true, closeOnClickOutside: true }
      );
    }
  }

  addCustomerFormGroup() {
    this.setValue("Number", this.model.Number);
    this.setValue("FirstName", this.model.FirstName);
    this.setValue("LastName", this.model.LastName);
    this.setValue("NumberTypeId", this.model.NumberTypeId);
    this.setValue("PhoneNumber", this.model.PhoneNumber);
    this.setValue("Address", this.model.Address);
    this.setValue("Description", this.model.Description);
    this.setValue("Title", this.model.Title);
    this.setValue("CategoryId", this.model.CategoryId);
    this.setValue("DetailLedgerId", this.model.Party?.DetailLedgerId);
    this.setValue("SubLedgerId", this.model.Party?.SubLedgerId);
    this.setValue("NationalCode", this.model.Party?.NationalCode);
    this.setValue("NationalId", this.model.Party?.NationalId);
    this.setValue("EconomicCode", this.model.EconomicCode);
    this.setValue("RegistrationNumber", this.model.RegistrationNumber);
    this.setValue("RegistrationDate", this.model.RegistrationDate);
    this.setValue("PostalCode", this.model.PostalCode);
  }

  onWrapperEnter($event: any) {
    if ($event.target.id !== "Address") {
      $event.preventDefault();
    }
  }

  private completeAddressGridValue(): void {
    this.model.Addresses.forEach((address) => {
      const selectedZone = this.zonesLookup?.find((x) => x.Id === address.ZoneId);
      const branchId = address.DefaultBranchId || selectedZone?.Branches?.find((f) => f.BranchId === selectedZone?.DefaultId)?.BranchId;
      const zoneBranchInfo = selectedZone?.Branches?.find((x) => x.BranchId === branchId);
      if (
        !(!this.isMultiBranch && address?.ShippingCost !== selectedZone?.ShippingCost) &&
        !(zoneBranchInfo && address.ShippingCost && address.ShippingCost !== zoneBranchInfo.ShippingCost)
      ) {
        address.ShippingCost = null;
      }
      if (address.IsDefault && this.formGroup.controls["DefaultBranches"].value !== selectedZone?.DefaultId) {
        address.DefaultBranchId = this.formGroup.controls["DefaultBranches"].value;
        const branchTitle = this.BranchLookUp?.find((x) => x.Id === address.DefaultBranchId)?.Title;
        address.DefaultBranchTitle = branchTitle;
      } else if (selectedZone && address.DefaultBranchId && address.DefaultBranchId !== selectedZone?.DefaultId) {
        const branchTitle = this.BranchLookUp?.find((x) => x.Id === address.DefaultBranchId)?.Title;
        address.DefaultBranchTitle = branchTitle;
      } else {
        address.DefaultBranchId = null;
        address.DefaultBranchTitle = null;
      }
      address.CourierShippingCost = null;
    });
  }

  private completePhoneNumberGridValue(): void {
    const { NumberTypeId } = this.formGroup.getRawValue();
    const defaultNumber = this.model.Numbers.find((a) => a.IsDefault);
    if (defaultNumber && NumberTypeId) defaultNumber.NumberTypeId = NumberTypeId;
  }

  private checkByPersonalityKindValidation() {
    if (this.model?.Party?.PersonalityKindCode == PersonalityKindEnum.Legalperson) {
      this.isNationalIdRequired = true;
      this.isNationalCodeRequired = false;
      this.hasLegalCustomer = true;
      this.hasPostalCode = true;
      this.hasEconomicCode = true;
      this.hasRegistrationNumber = true;
      this.hasRegistrationDate = true;
      this.NationalLabel = this.translate("ClientApp.FrontOffice.Parties.Customer.NationalID");
      this.formGroup.controls["NationalId"].addValidators(Validators.required);
      this.formGroup.controls["FirstName"].disable();
      this.disabledTitle = true;
    } else {
      this.isNationalIdRequired = false;
      this.isNationalCodeRequired = false;
      this.hasLegalCustomer = false;
      this.hasPostalCode = false;
      this.hasEconomicCode = false;
      this.hasRegistrationNumber = false;
      this.hasRegistrationDate = false;
      this.NationalLabel = this.translate("ClientApp.FrontOffice.Parties.Customer.NationalCode");
      this.formGroup.controls["NationalCode"].clearValidators();
      this.formGroup.controls["NationalId"].clearValidators();
      this.formGroup.controls["PostalCode"].clearValidators();
      this.formGroup.controls["FirstName"].enable();
      this.disabledTitle = false;
      this.haserror = false;
    }
    this.formGroup.controls["NationalId"].updateValueAndValidity();
    this.formGroup.controls["NationalCode"].updateValueAndValidity();
  }

  private setDefaultBranchId() {
    const defaultBranch = this.model?.Addresses?.find((f) => f.IsDefault);
    let defaultBranchId = defaultBranch?.DefaultBranchId
      ? defaultBranch?.DefaultBranchId
      : defaultBranch?.Zone?.Branches?.find((f) => f.IsDefault)?.BranchId;
    this.setValue("DefaultBranches", defaultBranchId);
  }

  private setValuesForOrderOnline() {
    if (this.Customer) {
      if (this.Customer.Address) this.model.Address = this.Customer.Address;
      if (this.Customer.Addresses) this.model.Addresses = this.Customer.Addresses;
      this.model.PhoneNumber = this.Customer.PhoneNumber;
      this.model.LastName = this.Customer.LastName;
      this.setValue("Address", this.Customer.Address);
      this.setValue("PhoneNumber", this.Customer.PhoneNumber);
      this.setValue("LastName", this.Customer.LastName);
      this.lookupService
        .getLookupbyCode("SALE", "NumberType", NumberType.Mobile)
        .pipe(take(1))
        .subscribe((x) => {
          this.model.NumberTypeId = x.Id;
          this.setValue("NumberTypeId", x.Id);
        });

      this.model.CategoryId = this.customerCategories[0]?.Id;
      this.setValue("CategoryId", this.customerCategories[0]?.Id);
    }
  }
  hasCreditCustomar() {
    const hasAccess = this.accountService.userHasPermission("RestaurantSale:Customer", "HasCreditCustomer");
    if (hasAccess) this.creditCustmer = true;
  }
}
